export default __webpack_public_path__ + "static/media/UploadedDocument.c15bf655.svg";